import { render } from "./String.vue?vue&type=template&id=2c2b5ac5&lang=pug"
import script from "./String.vue?vue&type=script&lang=ts"
export * from "./String.vue?vue&type=script&lang=ts"
script.render = render

export default script